// @flow
export const APP_TYPE_CABINET: 'cabinet' = 'cabinet';
export const APP_TYPE_JOURNAL: 'journal' = 'journal';
export const APP_TYPE_FOOD: 'food' = 'food';
export const APP_TYPE_DEALER: 'dealer' = 'dealer';
